import { createFileRoute } from '@tanstack/react-router';
import { redirectToAccessibleSetupPage } from '@/lib/setup-route-guard';
import SetupLayout from '@/pages/setup/SetupLayout';

export const Route = createFileRoute('/_authenticated/setup')({
  beforeLoad: async ({ location }) => {
    if (location.pathname === '/setup' || location.pathname === '/setup/') {
      // Not a hardcoded page: the user may lack permission for Organization,
      // whose guard would bounce them to the dashboard.
      await redirectToAccessibleSetupPage();
    }
  },
  component: SetupLayout,
});
